import React from "react";
import CheckBox from "./common/CheckBox";
import DropDown from "./common/DropDown";
import TextInput from "./common/TextInput";

function FoodForm(props) {
    return (
        <form onSubmit={props.onSubmit}>
            <TextInput id="name" label="Nombre" value={props.food.name} onChange={props.onChange} />
            <DropDown id="category" label="Categoria" value={props.food.category} onChange={props.onChange} list={[
                { "id": 1, "text": "Verduras" },
                { "id": 2, "text": "Frutas" },
                { "id": 3, "text": "Cereales y Leguminosas" },
                { "id": 4, "text": "Rico en grasas" },
                { "id": 5, "text": "Rico en proteinas" },
                { "id": 7, "text": "Rico en proteinas con grasas" },
                { "id": 6, "text": "Extra" }
            ]} />
            <TextInput id="portion" label="Porcion" value={props.food.portion} dataType="float" onChange={props.onChange} />
            <DropDown id="portionUnit" label="Unidad" value={props.food.portionUnit} onChange={props.onChange} list={[
                { "id": 1, "text": "gramos" },
                { "id": 2, "text": "miligramos" },
                { "id": 3, "text": "kilogramos" },
                { "id": 4, "text": "litros" },
                { "id": 5, "text": "mililitros" },
                { "id": 6, "text": "onzas" },
                { "id": 7, "text": "onzas liquidas" },
                { "id": 8, "text": "libras" },
                { "id": 9, "text": "tazas" },
                { "id": 10, "text": "cucharadas" },
                { "id": 11, "text": "pieza" }
            ]} />
            {props.food.portionUnit === 11 && (
                <div>
                    <TextInput
                        id="piecePortion"
                        label="Porcion de la pieza"
                        value={props.food.pielPortion}
                        dataType="float"
                        onChange={props.onChange}
                    />
                    <DropDown id="piecePortionUnit" label="Unidad de porcion de pieza" value={props.food.piecePortionUnit} onChange={props.onChange} list={[
                        { "id": 1, "text": "gramos" },
                        { "id": 2, "text": "miligramos" },
                        { "id": 3, "text": "kilogramos" },
                        { "id": 4, "text": "litros" },
                        { "id": 5, "text": "mililitros" },
                        { "id": 6, "text": "onzas" },
                        { "id": 7, "text": "onzas liquidas" },
                        { "id": 8, "text": "libras" },
                        { "id": 9, "text": "tazas" },
                        { "id": 10, "text": "cucharadas" }
                    ]} />
                </div>
            )}
            <TextInput id="calories" label="Calorias (kcal)" value={props.food.calories} onChange={props.onChange} dataType="float" />
            <TextInput id="carbs" label="Carbs (g)" value={props.food.carbs} onChange={props.onChange} dataType="float" />
            <TextInput id="proteins" label="Proteins (g)" value={props.food.proteins} onChange={props.onChange} dataType="float" />
            <TextInput id="fats" label="Fats (g)" value={props.food.fats} onChange={props.onChange} dataType="float" />
            <TextInput id="fibre" label="Fibra (g)" value={props.food.fibre} onChange={props.onChange} dataType="float" />
            <TextInput id="sodium" label="Sodio (mg)" value={props.food.sodium} onChange={props.onChange} dataType="float" />
            <CheckBox id="autoDiet" label="Usar en generacion de dieta" value={props.food.autoDiet} onChange={props.onChange} />
            <TextInput id="minPortion" label="Porcion minima" value={props.food.minPortion} dataType="float" onChange={props.onChange} />
            <TextInput id="maxPortion" label="Porcion maxima" value={props.food.maxPortion} dataType="float" onChange={props.onChange} />
            <input type="submit" value="Guardar" className="btn btn-primary" />
        </form>
    );
}

export default FoodForm;
